import React, { useState } from "react";
import { Worker, Viewer, SpecialZoomLevel } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { useTranslation } from 'react-i18next';

interface PDFViewerProps {
  pdfUrl: string;
}

const PDFViewer: React.FC<PDFViewerProps> = ({ pdfUrl }) => {
  const [error, setError] = useState<string>('');
  const { t } = useTranslation();
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  // Construct worker URL - use public folder first, fallback to CDN
  const workerUrl = `${process.env.PUBLIC_URL || ''}/pdf.worker.min.js`;

  return (
    <div className="w-full h-full bg-white dark:bg-gray-900 overflow-hidden flex flex-col">
      {error && (
        <div className="flex-shrink-0 bg-yellow-50 dark:bg-yellow-900 border-b border-yellow-200 dark:border-yellow-700 p-4 text-sm text-yellow-800 dark:text-yellow-200">
          {error}
        </div>
      )}
      <div className="flex-1 w-full overflow-auto">
        <Worker workerUrl={workerUrl}>
          <Viewer
            fileUrl={pdfUrl}
            plugins={[defaultLayoutPluginInstance]}
            defaultScale={SpecialZoomLevel.PageWidth}
            onDocumentLoad={() => {}}
            renderError={() => (
              <div className="p-4 text-center text-red-600 dark:text-red-400">
                {t('Failed to render PDF. The file may be corrupted or unsupported.')}
              </div>
            )}
          />
        </Worker>
      </div>
    </div>
  );
};

export default PDFViewer;
